import { css } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

import ButtonDefault from "components/DesignComponents/ButtonDefault";
import { svgFontSize } from "shared/styles/styleFunctions";
import { body1SemiBold, body3Regular } from "shared/styles/typography";

import { BoxProps } from "./types";

const Box = ({ title, description, icon, isSelected, onClick }: BoxProps) => {
    const { blue100, blue700, gray300, gray700, white } = colors;

    return (
        <ButtonDefault
            type="button"
            onClick={onClick}
            css={css({
                flex: "1",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center",
                border: `1px solid ${gray300}`,
                background: isSelected ? blue100 : white,
                borderRadius: "8px",
                padding: "15px",
                transition: "all 0.3s ease-in-out",

                "&:hover": {
                    background: blue100,
                    cursor: "pointer"
                }
            })}
        >
            <div
                css={css({
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: blue700,
                    background: blue100,
                    borderRadius: "8px",
                    padding: "4px",

                    "& > svg": {
                        ...svgFontSize(32)
                    }
                })}
            >
                {icon}
            </div>

            <div css={[body1SemiBold, { margin: "16px 0 8px 0" }]}>{title}</div>

            <div css={[body3Regular, { color: gray700 }]}>{description}</div>
        </ButtonDefault>
    );
};

export default Box;
